export const KaizenLogo = ({ className }: { className?: string }) => {
    return (
        <svg
            id="kaizen-logo-xmas"
            viewBox="30 25 182 53"
            className={`fill-current ${className ?? ""}`}
        >
            <title>Kaizen</title>
            <path
                fill="#0070f0"
                d="M71.6 26.4 55.5 62.5l-6.9-11.7h-8l16.6 26.3 22.4-50.7h-8z"
            ></path>
            <path d="M98.6 26.4h7.2v38.4h-7.2V26.4zm12.9 0H141v3.4l-19.9 28.1H141l-4.9 6.9H111v-4.2l19.4-27.4h-18.9v-6.8zm57.1 38.4h-23.4V26.4H174l-5.4 7h-16.2v8.8h20.8l-5.4 6.8h-15.4v8.6H174l-5.4 7.2zm35.1-38.4h7.3v38.4h-4.5l-20.2-25.9v25.9h-7.2V26.4h5.8l18.8 23.8V26.4zM45.2 45l16.4-18.6h-8.4L38.7 42.6V26.4h-7.3v38.4h7.3v-17l1.9 3h8L45.2 45zm34.4-18.6-3.8 8.5 7 15.9h-14l-3 6.7h19.9l3.2 7.3h7.9L79.6 26.4zm142.8 3.4c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4 4 1.8 4 4zm-4-3.1a3.1 3.1 0 0 0-3.1 3.1c0 1.7 1.4 3.1 3.1 3.1s3.1-1.4 3.1-3.1-1.3-3.1-3.1-3.1z"></path>
            <path d="m219.9 31.8-1-1.6c.5-.2.9-.5.9-1.2 0-.9-.7-1.2-1.5-1.2H217v4.1h.7v-1.6h.6l.8 1.5h.8zm-2.3-2.1v-1.3h.6c.6 0 .9.1.9.6s-.3.7-.9.7h-.6z"></path>
        </svg>
    );
};
